import moment from 'moment';
import jwtDecode from 'jwt-decode';
import Product from '@/entities/Product';
import { db, firebase } from '@/vendors/firebase/firebase';

const ls = require('local-storage');

const hourMorning = 18;
const hourEvening = 19;

export default {
  async getProductsByStore() {
    const shopToken = ls.get('shopToken');
    const { shopId: storeId } = jwtDecode(shopToken);
    console.log('storeId');
    console.log(storeId);

    const transformedReponseData = [];
    // let quantity;
    // const hourMorning = 16;
    // const hourEvening = 18;

    const today = new Date();
    const hour = today.getHours();

    const date = moment();

    if (hour >= hourMorning && hour < hourEvening) {
      return new Promise((resolve) => resolve(transformedReponseData));
    }

    if (hour < hourMorning) {
      date.subtract(1, 'days');
    }

    await db.collection('shops').doc(storeId).collection('listProducts').get()
      .then((querySnapshot) => {
        querySnapshot.forEach(async (doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());

          // const product = { ...doc.data(), date: moment(new Date()).format('DD/MM/YYYY') };
          const product = { ...doc.data(), date: date.format('DD/MM/YYYY') };
          transformedReponseData.push(new Product(product));
        });
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(transformedReponseData));
    // return true;
  },
  async setQuantityInventory(data) {
    const today = new Date();
    const hour = today.getHours();
    if (hour >= hourMorning && hour <= hourEvening) {
      console.log('on passe dans le reject');
      return new Promise((resolve) => resolve(null));
    }

    const momentObj = moment(data.date, 'DD/MM/YYYY');
    const dateString = momentObj.format('YYYY-MM-DD');
    const inventoryRef = db.collection('shops').doc(data.storeId)
      .collection('listProducts')
      .doc(data.productId);

    const isCompleted = data.stockJ !== null && data.stockJ !== undefined;

    const product = {
      ...data,
      isCompleted,
      date: firebase.firestore.Timestamp.fromDate(new Date(dateString)),
    };

    // const result = await inventoryRef.set(product, { merge: true });
    const result = await inventoryRef.update(product);

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(result));
    // return true;
  },
  async getListingProductId() {
    const transformedReponseData = [];
    console.log('listing des product ID');
    await db.collection('listingProducts')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' ==> ', doc.data());
          transformedReponseData.push(doc.data());
        });
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(transformedReponseData));
    // return true;
  },
  displayDateSaisie() {
    const today = new Date();
    const hour = today.getHours();

    const date = moment();
    if (hour <= hourMorning) {
      date.subtract(1, 'days');
    }

    date.set({ hour: 20, minute: 0 });

    return date.format('DD/MM/YYYY HH:mm');
  },
};
